import React, { Component} from 'react'

class Dashboard extends Component {
  render() {
    return (
      <div>
        Dashboard view
      </div>
    )
  }
}


export default Dashboard
